import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

export const FormPageSkeleton = () => (
  <Stack gap={4}>
    <Stack>
      <Typography variant="h1">
        <Skeleton variant="text" sx={{ maxWidth: 400 }} />
      </Typography>
      <Typography>
        <Skeleton variant="text" sx={{ maxWidth: 300 }} />
      </Typography>
    </Stack>
    <Skeleton variant="rounded" height={400} />
  </Stack>
);
